



























































































import { Component, Vue } from "vue-property-decorator";
import VLetterIcon from "@/components/VLetterIcon.vue";
import ColorHelper from "../../utils/ColorHelper";

@Component({
  components: {
    VLetterIcon,
  },
})
export default class Icons extends Vue {
  color = ColorHelper.random();
  colors: Array<string> = [];

  created() {
    ColorHelper.reset();

    for (let i = 1; i <= ColorHelper.totalColors; i++) {
      this.colors.push(ColorHelper.pick());
    }
  }
}
